import React, { useEffect } from 'react';
import { connect } from 'react-redux';
import { Redirect } from 'react-router-dom';
import { AppState, ConnectedPropsWithoutDispatch } from '../../../../stores/redux-store';
import { buildDeviceHandoffPaySessionUrl, buildDeviceHandoffUrl } from '../../../../routes';
import { useProduct } from '../../../../components/ApplicationProviders/ProductProvider/ProductProvider';
import { useVersion } from '../../../../components/ApplicationProviders/VersionProvider/VersionProvider';
import { useLegal } from '../../../../components/ApplicationProviders/LegalProvider/LegalProvider';
import { PageView } from '../../../../models/analytics';

type DeviceHandoffLandingProps = PropsFromRedux;

export const DeviceHandoffLandingPresenter: React.FC<DeviceHandoffLandingProps> = ({
  session,
  handoffSession,
}: DeviceHandoffLandingProps) => {
  const { productType, productDimension } = useProduct();
  const {
    version: { version },
  } = useVersion();
  const { setLegalDisclaimerPageView } = useLegal();

  useEffect(() => {
    setLegalDisclaimerPageView(PageView.CONSENT_SCREEN);
  }, [setLegalDisclaimerPageView]);

  const sourceAccountNumber = session?.sourceAccountNumber;
  const providerName = handoffSession?.providerName || '';

  if (sourceAccountNumber) {
    return (
      <Redirect
        to={buildDeviceHandoffPaySessionUrl({
          version,
          productDimension,
          productType,
          providerName,
        })}
      />
    );
  }

  return (
    <Redirect
      to={buildDeviceHandoffUrl({ providerName, productType, productDimension, version })}
    />
  );
};

const mapStateToProps = (state: AppState) => {
  return {
    handoffSession: state.handoffSession.data,
    session: state.session.data,
  };
};

const connector = connect(mapStateToProps);

type PropsFromRedux = ConnectedPropsWithoutDispatch<typeof connector>;

export const DeviceHandoffLanding = connector(DeviceHandoffLandingPresenter);
